export default "__VITE_ASSET__BNb6epKx__"